import usePurchasesViewModel from './PurchasesViewModel'
import useDocumentPopupHandler from '@hook/useDocumentPopupHandler'
import { formatDate, relativeTime } from '@utils/date'
import cn from 'clsx'

import SettingsWrapper from '../SettingsWrapper'
import { hasNoFile } from '@constants'
import { BsEyeFill } from 'react-icons/bs'
import { DocumentViewerModal } from '@components/collection/DocumentViewerV2'
import CircleSpinner from '@components/shared/CircleSpinner'

const Purchases = () => {
    
    const vm = usePurchasesViewModel()
    
    const { popupDocumentOrNavigate } = useDocumentPopupHandler()
    
    return (
        
        <SettingsWrapper
            title="Purchases"
            subtitle="Most recent 50 purchases"
            rightContent={
                <div className="flex justify-end items-center gap-4">
                    <ul className="menu bg-base-200 lg:menu-horizontal rounded-box">
                        <li>
                            <a
                                className={cn({ active: vm.filterMode === 'mine' })}
                                onClick={e => {
                                    e.preventDefault()
                                    vm.setFilterMode('mine')
                                }}>
                                My Purchases
                            </a>
                        </li>
                        <li>
                            <a
                                className={cn({ active: vm.filterMode === 'my-orgs' })}
                                onClick={e => {
                                    e.preventDefault()
                                    vm.setFilterMode('my-orgs')
                                }}>
                                My Organizations
                            </a>
                        </li>
                        <li>
                            <a
                                className={cn({ active: vm.filterMode === 'current-org' })}
                                onClick={e => {
                                    e.preventDefault()
                                    vm.setFilterMode('current-org')
                                }}>
                                Current Organization
                            </a>
                        </li>
                    </ul>
                </div>
            }>
            
            {!vm.error && !vm.loading && !vm.purchases?.length && (
                <p>No recent purchases found.</p>
            )}
            
            {vm.error && (
                <div className="alert alert-danger">
                    {vm.error}
                </div>
            )}
            
            {vm.loading && (
                <CircleSpinner className="absolute-centered"/>
            )}
            
            {!vm.error && !vm.loading && vm.purchases?.length > 0 && (
                <table className="table-auto">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Member</th>
                            <th>Organization</th>
                            <th>Collection</th>
                            <th>Document</th>
                        </tr>
                    </thead>
                    <tbody>
                        {vm.purchases?.map(it => (
                            <tr key={it.id}>
                                <td title={formatDate(it.updatedAt)} onClick={() => console.log(it)}>
                                    {relativeTime(it.updatedAt)}
                                </td>
                                <td>{it.user.email}</td>
                                <td>{it.organization.name}</td>
                                <td>{it.document.collection?.name}</td>
                                <td>
                                    <div className="flex gap-2"
                                        data-tooltip-id="default-tip"
                                        data-tooltip-content={hasNoFile(it.document)
                                            ? 'Index record only. No document record is available to View'
                                            : ''}>
                                        <button
                                            className="view-document-btn p-2 btn btn-primary btn-sm btn-square"
                                            disabled={hasNoFile(it.document)}
                                            onClick={popupDocumentOrNavigate(it.document)}
                                            rel="noreferrer">
                                            <BsEyeFill data-tooltip-id="default-tip" data-tooltip-content="View" />
                                        </button>
                                        <span>{it.document.name}</span>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            
            <DocumentViewerModal />
        
        </SettingsWrapper>
        
    )
    
}

export default Purchases
